import { IParcelDetail } from "../../../models/parcel/IParcelDetail";

export function filterVisibleParcels(
    parcels: IParcelDetail[],
    auctionCompleted: boolean
): IParcelDetail[] {
    if (!auctionCompleted) {
        return parcels;
    }

    // En bloc sales are not currently tied back to their regular parcels.
    // Until https://github.com/clhbid/CLHbid-LiveAuction/issues/459 is done,
    // an admin may need to manually add a bid on a no-sale regular parcel
    // that was included in a winning en bloc before it will appear as sold.
    return parcels.filter((p) => !p.isNoSale);
}
